import React from "react";
import { Toaster } from "react-hot-toast";

function ToasterProvider() {
  return (
    <div>
      <Toaster />
    </div>
  );
}

export default ToasterProvider;
